import { createLayerCanvas, drawPointsPath, toDataUrl } from './canvasUtils'
import { extractLandmarkFeatures } from './extractLandmarkFeatures'

export const buildEyesLayer = ({ landmarks, width, height, features = null }) => {
  if (!landmarks?.length) return null
  const featureMap = features || extractLandmarkFeatures({ landmarks, width, height })
  const leftEye = featureMap?.eyes?.left?.polygon || []
  const rightEye = featureMap?.eyes?.right?.polygon || []
  if (!leftEye.length && !rightEye.length) return null
  const { canvas, ctx } = createLayerCanvas(width, height)
  if (leftEye.length) {
    drawPointsPath(ctx, leftEye, {
      close: true,
      fill: 'rgba(129, 140, 248, 0.56)'
    })
  }
  if (rightEye.length) {
    drawPointsPath(ctx, rightEye, {
      close: true,
      fill: 'rgba(129, 140, 248, 0.56)'
    })
  }
  return toDataUrl(canvas)
}
